<template>
    <div class="products-details">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'productsSummary' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Promotion Details
                        </div>
                    </div>      

                    <div class="col-md-4">
                       <div class="top-navbar-right">
                            <button class="btn btn-ecdc" @click="$router.push({ name: 'productsPromotionCreate' });">Create Promotion</button>
                        </div>
                    </div>                       
                </div>
            </div>

            <hr />

            <div class="row">
                <transition name="fade" mode="out-in">
                    <div v-show="toggleFilter" id="side-filter-col" class="col-lg-3">
                        <div class="side-filter">

                            <div class="title">
                                Filter
                            </div> 

                            <div class="form-group">
                                <div class="label">Year</div>
                                <select class="form-control custom-select" v-model="filter.year">
                                    <option value="2020">2020</option>
                                    <option value="2019">2019</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <div class="label">Months</div>
                                <app-multi-select 
                                    :options="monthOptions.map(monthOption => monthOption.id)"  
                                    :custom-label="opt => monthOptions.find(x => x.id == opt).name"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true" 
                                    :preselect-first="false"
                                    :placeholder="'-- All Months --'"
                                    v-model="filter.month">
                                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                                </app-multi-select>

                                <div class="selected-label" v-if="filter.month.length > 0">
                                    FILTER:
                                    <div v-for="month in filter.month" :key="month">{{ monthOptions.find(x => x.id == month).name}}</div>
                                </div>
                            </div>

                            <div class="filter-action">
                                <button type="button" class="btn btn-ecdc btn-block" @click="setFilter()">Apply</button>
                                <button type="button" class="btn btn-link btn-block text-light" @click="clearFilter()">Clear Filter</button>
                            </div>
                        </div>
                    </div>
                </transition>

                <div id="table-content-col" :class="toggleFilter ? 'col-lg-9 filter-expanded' : 'col-lg'">

                    <div class="table-options row justify-content-between align-items-center">
                        <div class="col-sm">
                            <button @click='toggleFilter = !toggleFilter' type="button" class="btn btn-ecdc btn-filter">Filter</button>

                            <!-- <div class="table-search form-inline d-inline-block ml-4">
                                <input type="text" class="form-control" placeholder="Search by keyword">                         <button type="button" class="btn btn-ecdc btn-circle">
                                    <app-icon-search></app-icon-search>
                                </button>       
                            </div> -->
                        </div>
                        <div class="col-sm mt-3 mt-sm-0">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateTop"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-striped result-table">
                            <thead>
                                <tr>
                                    <th>Promotion Name</th>
                                    <th>Promotion Price</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Created On</th>
                                    <th>Last Edited</th>
                                    <th>Status</th>
                                    <th class="text-center">ACTION</th>
                                </tr>
                            </thead>

                            <tbody v-if="!isLoading">
                                <tr v-for="product in productsData.data" v-bind:key="product.id">
                                    <td>{{ product.name }}</td>
                                    <td>{{ product.price }}</td>
                                    <td>{{ product.start_date }}</td>
                                    <td>{{ product.end_date }}</td>
                                    <td>{{ product.created_at }}</td>
                                    <td>{{ product.updated_at }}</td>
                                    <td v-if="new Date() <= new Date(product.end_date)">Ongoing</td>
                                    <td v-if="new Date() > new Date(product.end_date)">Ended</td>
                                    <td class="text-center" @click="edit(product.id)">
                                        <button class="btn btn-link btn-icon icon-right">
                                            Edit 
                                            <img class="icon" src="../assets/img/icon-edit.png" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="row justify-content-between align-items-center table-options">
                        <div class="col-lg col-6">
                            <select class="form-control custom-select" v-model="pageLimit" @change="pagination(1)">
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            per page
                        </div>
                        <div class="col-lg text-lg-center text-right col-6">
                            {{ showingResults }}
                        </div>
                        <div class="col-lg mt-lg-0 mt-3">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateBottom"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { getPromotions } from '../api'
import Loader from './Loader.vue'
import Paginate from 'vuejs-paginate'
// import IconSearch from '../svg/Search.vue'
import Multiselect from 'vue-multiselect'

export default {
    components: {
        appLoader: Loader,
        appPaginate: Paginate,
        // appIconSearch: IconSearch,
        appMultiSelect: Multiselect
    },
    data() {
        return {
            filter: {
                year: "2020",
                month: []
            },
            monthOptions: [
                { name: 'January', id: 1 },
                { name: 'Febuary', id: 2 },
                { name: 'March', id: 3 },
                { name: 'April', id: 4 },
                { name: 'May', id: 5 },
                { name: 'June', id: 6 },
                { name: 'July', id: 7 },
                { name: 'August', id: 8 },
                { name: 'September', id: 9 },
                { name: 'October', id: 10 },
                { name: 'November', id: 11 },
                { name: 'December', id: 12 }
            ],
            productsData: "",
            isLoading: true,
            totalPage: 0,
            pageLimit: 15,
            showingResults: "",
            toggleFilter: true
        }
    },
    async mounted() {

        await this.getPromotions(1);
        this.isLoading = false;
    },
    methods: {
        async pagination(pageNum) {

            this.isLoading = true;
            
            if(pageNum != 0)
                this.$refs.paginateTop.selected = this.$refs.paginateBottom.selected = pageNum;
            else 
                pageNum = this.$refs.paginateBottom.selected;

            await this.getPromotions(pageNum);

            this.isLoading = false;
        },
        async getPromotions(pageNum) {

            try {
                
                const result = await getPromotions(this.filter, pageNum, this.pageLimit);    
                this.productsData = result.data.data;
                this.totalPage = this.productsData.total / this.pageLimit;

                if(this.totalPage % 1 != 0)
                    this.totalPage = parseInt(this.totalPage) + 1;
                else
                    this.totalPage = parseInt(this.totalPage);

                var startPage = 1;
                
                if(pageNum != 1)
                    startPage = (this.pageLimit * (pageNum - 1)) + 1;

                var endPage = pageNum * this.pageLimit;

                if(endPage >= this.productsData.total)
                    endPage = this.productsData.total;

                this.showingResults = "Showing " + startPage + " - " + endPage + " of " + this.productsData.total + " results";
            }
            catch(err) {

                alert(err.response.data.message);
            }
        },
        clearFilter() {
            
            this.filter.year = "2020";
            this.filter.month = [];
        },
        async setFilter() {

            this.isLoading = true;
            await this.getPromotions(1);
            this.isLoading = false;
        },
        edit(id) {
            this.$router.push({ name: "productsPromotionEdit" , params: { 'id': id }}) ;
        }
    }
}
</script>